import { useContext } from 'react';

import { IEspClient } from '../IEspClient';

import { EspClientContext } from './EspClientContext';

export function useEspClient (): IEspClient | null {
    return useContext(EspClientContext);
}
